import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import BookingForm from "./components/BookingForm";
import About from "./components/About";
import Rates from "./components/Rates"; // ✅ Add this line
import Services from "./components/Services";
import Footer from "./components/Footer";
import Fleet from "./components/Fleet"; 
import AdminDashboard from "./components/AdminDashboard";


import Contact from "./components/Contact"; // 👈 add this import
import "./styles/navbar.css";
import "./styles/home.css";
import "./styles/booking.css";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<BookingForm />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
         <Route path="/rates" element={<Rates />} /> {/* ✅ Add this line */}
         <Route path="/contact" element={<Contact />} /> {/* 👈 add this */}
         <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
